import { render, staticRenderFns } from "./AllStartTask.vue?vue&type=template&id=6a9a10b4&scoped=true&"
import script from "./AllStartTask.vue?vue&type=script&lang=js&"
export * from "./AllStartTask.vue?vue&type=script&lang=js&"
import style0 from "./AllStartTask.vue?vue&type=style&index=0&id=6a9a10b4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a9a10b4",
  null
  
)

export default component.exports